import { BASE_URL } from './config'

async function fetchWithHandling(url: string, options: RequestInit) {
  const response = await fetch(url, options)
  if (!response.ok) {
    let errorMessage = 'An error occurred'
    try {
      const errorData = await response.json()
      errorMessage = errorData.message || errorMessage
    } catch (e) {
      errorMessage = response.statusText
    }
    throw new Error(errorMessage)
  }
  return response.json()
}

export async function getAlerts(token: string) {
  return fetchWithHandling(`${BASE_URL}/api/v1/alerts`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

export async function resolveAlert(token: string, id: string) {
  return fetchWithHandling(`${BASE_URL}/api/v1/alerts/${id}/resolve`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
}
